<template>
  <div class="form">
    <div :class="{formParent: formClass}">
      <b-form v-if="show">
        <div class="f_group">
          <b-form-group id="input-group-1" label="First Name*:" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="form.firstName"
              name="first_name"
              required
              placeholder="Enter first name"
            ></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-8" label="Last Name*:" label-for="input-8">
            <b-form-input
              id="input-8"
              v-model="form.lastName"
              name="last_name"
              required
              placeholder="Enter last name"
            ></b-form-input>
          </b-form-group>
        </div>

        <div class="f_group">
          <b-form-group id="input-group-2" label="Email address*:" label-for="input-2">
            <b-form-input
              id="input-2"
              v-model="form.email"
              type="email"
              required
              placeholder="Enter email"
              name="email"
            ></b-form-input>
          </b-form-group>

          <b-form-group id="input-group-3" label="Phone number*:" label-for="input-3">
            <b-form-input
              id="input-3"
              v-model="form.phone"
              type="text"
              v-mask="'+1 (###)-###-####'"
              required
              placeholder="+1 (---) --- ----"
              name="phone"
            ></b-form-input>
          </b-form-group>
        </div>

        <b-form-group id="input-group-4" label="State*:" label-for="input-4">
          <b-form-select
            id="input-4"
            name="state"
            v-model="form.state"
            :options="unitedState"
            required
          >
            <template v-slot:first>
              <b-form-select-option :value="null" disabled>Choose state</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>

        <b-form-group id="input-group-5" label="Debt Amount*:" label-for="input-5">
          <b-form-select
            id="input-5"
            v-model="form.debt"
            name="debt"
            :options="debtAmount"
            required
          >
            <template v-slot:first>
              <b-form-select-option :value="null" disabled>Choose debt amount</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>

        <b-form-group id="input-group-6" label="Company name*:" label-for="input-6">
          <b-form-input
            id="input-6"
            v-model="form.company"
            type="text"
            required
            placeholder="Enter company"
            name="company"
          ></b-form-input>
        </b-form-group>

        <b-button @click.prevent="onSubmit" type="submit" variant="primary">Submit</b-button>
        <b-alert
          v-model="showDismissibleAlert"
          variant="danger"
          dismissible
        >Please fill out the form!</b-alert>
      </b-form>
    </div>
    <div :class="{form_success: formClass}">
      <h1 class="noneD">
        Thank you!
        <i class="far fa-check-circle"></i>
      </h1>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sent: false,
      showDismissibleAlert: false,
      form: {
        email: "",
        firstName: "",
        lastName: "",
        phone: "",
        company: "",
        completed: false,
        state: null,
        debt: null,
        id: Date.now(),
        time: `${[
          new Date().getDate(),
          new Date().getMonth() + 1,
          new Date().getFullYear()
        ]
          .map(n => (n < 10 ? `0${n}` : `${n}`))
          .join("/")} -  ${new Date()
          .toLocaleTimeString()
          .slice(0, -6)} ${new Date()
          .toLocaleTimeString()
          .slice(-2, new Date().toLocaleTimeString().length)}`
      },
      debtAmount: [
        "Under $50,000",
        "$50,000 - $100,000",
        "$100,000 - $500,000",
        "$500,000 - $1,000,000",
        "$1,000,000 - $5,000,000",
        "$5,000,000 - $15,000,000",
        "$15,000,000 +"
      ],
      unitedState: [
        "Alabama",
        "Alaska",
        "American Samoa",
        "Arizona",
        "Arkansas",
        "California",
        "Colorado",
        "Connecticut",
        "Delaware",
        "District of Columbia",
        "Federated States of Micronesia",
        "Florida",
        "Georgia",
        "Guam",
        "Hawaii",
        "Idaho",
        "Illinois",
        "Indiana",
        "Iowa",
        "Kansas",
        "Kentucky",
        "Louisiana",
        "Maine",
        "Marshall Islands",
        "Maryland",
        "Massachusetts",
        "Michigan",
        "Minnesota",
        "Mississippi",
        "Missouri",
        "Montana",
        "Nebraska",
        "Nevada",
        "New Hampshire",
        "New Jersey",
        "New Mexico",
        "New York",
        "North Carolina",
        "North Dakota",
        "Northern Mariana Islands",
        "Ohio",
        "Oklahoma",
        "Oregon",
        "Palau",
        "Pennsylvania",
        "Puerto Rico",
        "Rhode Island",
        "South Carolina",
        "South Dakota",
        "Tennessee",
        "Texas",
        "Utah",
        "Vermont",
        "Virgin Island",
        "Virginia",
        "Washington",
        "West Virginia",
        "Wisconsin",
        "Wyoming"
      ],
      show: true,
      formClass: false,
      successForm: false
    };
  },
  methods: {
    onSubmit() {
      if (
        this.form.email == "" ||
        this.form.firstName == "" ||
        this.form.lastName == "" ||
        this.form.phone == "" ||
        this.form.company == "" ||
        this.form.state == null ||
        this.form.debt == null
      ) {
        this.showDismissibleAlert = true;
      } else {
        this.$store.dispatch("addMessage", this.form);
        this.formClass = true;
        this.successForm = true;
        this.form.email = "";
        this.form.firstName = "";
        this.form.lastName = "";
        this.form.phone = "";
        this.form.company = "";
        this.form.state = null;
        this.form.debt = null;
      }
    }
  }
};
</script>

<style lang="scss">
.formParent {
  display: none;
}
.noneD {
  display: none;
}
.form_success {
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(85, 184, 85);
  height: 100%;
  .noneD {
    display: block;
  }
}
.alert {
  margin-top: 10px;
}
.form {
  width: 90%;
  margin: 0 auto;
  .form-group {
    label {
      margin-bottom: 0 !important;
      font-size: 14px;
    }
  }
}
.f_group {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>